<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <div class="hidden md:col-span-2 md:block" />

            <div class="col-span-12 overflow-y-auto text-left md:col-span-8">
                <h2 class="mb-5">Kontakt</h2>
                <p>
                    V případě dotazů, podnětů, hlašení chyb v obsahu, či
                    funkčnosti aplikace nás neváhejte kontaktovat.
                </p>

                <!-- <div class="mt-10">
                    <p class="text-[16px] font-bold">Vyberte téma</p>
                    <label class="mb-2 flex items-center">
                        <input
                            type="radio"
                            name="tema"
                            value="dotaz"
                            class="mr-2"
                            disabled
                        />
                        <p class="par-16 text-gray-400">Obsah encyklopedie</p>
                    </label>
                    <label class="mb-2 flex items-center">
                        <input
                            type="radio"
                            name="tema"
                            value="podnet"
                            class="mr-2"
                            disabled
                        />
                        <p class="par-16 text-gray-400">Technické problémy</p>
                    </label>
                </div>

                <div class="mt-5">
                    <p class="text-[16px] font-bold">E-mail</p>
                    <input
                        type="email"
                        class="w-full border bg-white p-2 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
                        placeholder=""
                        required
                        disabled
                    />
                </div>
                <div class="mt-5">
                    <p class="text-[16px] font-bold">Vaše zpráva</p>
                    <textarea
                        rows="4"
                        class="min-h-[154px] w-full border bg-white p-2 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
                        placeholder=""
                        disabled
                    />
                </div>

                <div class="mt-5 mb-5 flex justify-center">
                    <button
                        class="cursor-pointer rounded-full bg-[#F01F26] px-8 py-2 text-white hover:bg-[#D01A22] focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
                        disabled
                    >
                        Odeslat
                    </button>
                </div>
                <div class="mt-5 mb-25 flex justify-center">
                    <p>
                        Zpětnou vazbu zasílejte na e-mail
                        <a
                            href="mailto:magdalena.rollova@praha.eu"
                            class="article-link"
                            >magdalena.rollova@praha.eu</a
                        >.
                    </p>
                </div> -->

                <ClientOnly>
                    <bug-reporting />
                </ClientOnly>
            </div>

            <div class="hidden md:col-span-2 md:block" />
        </div>
        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
